export type ContractStatus =
  | 'pending'
  | 'applied'
  | 'deposit_paid'
  | 'mvp_ready'
  | 'mvp_confirmed'
  | 'signed'
  | 'completed';

export type ApplicationSource = 'inquiry' | 'contract';

export type Contract = {
  id: number;
  // 2026-09-18: 신청(inquiries)~MVP확인 단계는 'inquiry', 전자서명(계약 체결) 이후는 'contract'.
  // 어느 API(/inquiry/:id/... vs /api/admin/contracts/:id/...)를 호출할지 이 값으로 분기한다.
  source: ApplicationSource;
  customer_name: string;
  phone: string;
  contract_type: string;
  contract_name: string | null;
  company_name: string | null;
  representative: string | null;
  email: string | null;
  /** 신청서의 관리자 로그인 이메일(비워 두면 신청자 이메일로 채워져 내려옴) */
  admin_email?: string | null;
  /** 신청 시 서버가 계산한 월 요금 */
  monthly_amount?: number | null;
  status: ContractStatus;
  created_at: string;
  member_size: string | null;
  selected_member_tabs: string[];
  selected_admin_tabs: string[];
  sundayschool_addon: boolean;
  design_concept: string | null;
  applicant_message: string | null;
  plan_type: string | null;
  logo_url: string | null;
  /** 신청(source='inquiry')에 첨부된 고유번호증 원본 파일명. 없으면 null/undefined */
  registration_cert_name?: string | null;
  /** 신청서의 MVP(시안) 테스트 기기 — 플랫폼(android/ios), 아이폰이면 Apple 계정 이메일 */
  test_platforms?: string[];
  test_apple_emails?: string[];
  /** 개발자 계정 등록 방식 — self(직접) / shared(계정 공유 후 대행) / agency(모두 대행), 미선택 null */
  developer_account_method?: 'self' | 'shared' | 'agency' | null;
  /** MVP 시안 미리보기 링크·담당자 메모(관리자가 "MVP 준비처리"에서 입력), 고객 확인 시각 */
  mvp_preview_url?: string | null;
  mvp_note?: string | null;
  mvp_confirmed_at?: string | null;
  deposit_confirmed_at: string | null;
  deposit_confirmed_by: string | null;
  balance_confirmed_at: string | null;
  balance_confirmed_by: string | null;
};

export type ApiEnvelope<T> = {
  ok: boolean;
  data?: T;
  message?: string;
};

export const STATUS_LABEL: Record<ContractStatus, string> = {
  pending: '서명 대기(구)',
  applied: '신청 접수',
  deposit_paid: '선결제 완료',
  mvp_ready: 'MVP 준비완료',
  mvp_confirmed: 'MVP 확인완료',
  signed: '계약 서명완료',
  completed: '최종결제 완료',
};

export function formatDateTime(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${yyyy}.${mm}.${dd} ${hh}:${min}`;
}

// 신청서 진행 상태 순서: applied(1단계) -> deposit_paid(2단계) -> mvp_ready/mvp_confirmed(3단계)
// -> signed(4단계) -> completed(5단계). 관리자 콘솔 "신청목록" 메뉴가 이 3그룹으로 나뉜다.
export const APPLICATION_LIST_STATUSES: ContractStatus[] = ['pending', 'applied'];
export const PREPAID_LIST_STATUSES: ContractStatus[] = ['deposit_paid'];
export const PAYMENT_PENDING_LIST_STATUSES: ContractStatus[] = ['mvp_ready', 'mvp_confirmed', 'signed'];
